import { render, staticRenderFns } from "./message-record-recharge.vue?vue&type=template&id=36e63c9f&"
import script from "./message-record-recharge.vue?vue&type=script&lang=js&"
export * from "./message-record-recharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports